export const KNOWLEDGE_BASE_URL_FOR_CUSTOM_SENDER_EMAIL =
  'https://help.eventmobi.com/en/knowledge/how-can-i-make-sure-that-emails-from-the-app-use-my-preferred-email-address';
